/** @file PoseButtons: Reset to rest and Copy to twin for the selected node at the playhead. */
import type { Command } from '@zilo/pose3d-commands/types/command';
import type { ReactElement } from 'react';
import { useEditor } from '../../state/useEditor';
import { useEditorStore } from '../../state/useEditorStore';
import { mirrorGuard } from '../timeline/mirrorGuard';
import { poseCommand } from '../timeline/poseCommand';
import type { JointEdit } from './useJointEdit';

const button = { font: 'inherit', fontSize: 11, padding: '1px 6px' };

/** Each button sends one command at the playhead (refused, with the mirror toast, in the mirrored half). */
export function PoseButtons({ edit, node }: { edit: JointEdit; node: string }): ReactElement {
  const store = useEditorStore();
  const twin = useEditor((s) => s.puppet.doc?.puppet.nodes[node]?.mirror);
  const rest = useEditor((s) => s.puppet.doc?.puppet.nodes[node]?.rest);
  const { clipName, clip, frame } = edit;
  const send = (label: string, command: Command): void => {
    const s = store.getState();
    if (!mirrorGuard(clip, frame, s.notify)) void s.dispatch([command], label);
  };
  return (
    <div style={{ display: 'flex', gap: 6 }}>
      <button type="button" style={button}
        onClick={() => { send(`reset ${node}`, poseCommand(clipName, clip, frame, { [node]: { rot: rest ?? [0, 0, 0] } })); }}>Reset to rest</button>
      <button type="button" style={button} disabled={twin === undefined} title={twin === undefined ? 'no mirror twin' : `writes ${twin}`}
        onClick={() => { send(`mirror ${node}`, { name: 'clip.mirrorPose', input: { clip: clipName, frame, nodes: [node] } }); }}>Copy to twin</button>
    </div>
  );
}
